export class AuditRecord  {

    public dateTimeOfChange: number
    public changeLocation: string //indicate the page the change was made. i.e. Algebra, license, testing, etc
    public actionTaken: string  // Upload, delete, update, etc
    public uploadId?: string
    public formChanges?: any

    constructor()
    constructor(uploadIdInput: string)
    constructor(uploadIdInput?: string){
        this.dateTimeOfChange = Date.now();
        this.changeLocation = "Not Defined";
        this.actionTaken = "Not Defined";
        if(uploadIdInput){
            this.uploadId = uploadIdInput;
        }

    }

    public package(): IAuditRecord{
        if(this.uploadId){            
            return {
                dateTimeOfChange: this.dateTimeOfChange,
                changeLocation: this.changeLocation,
                actionTaken:this.actionTaken,
                uploadId:this.uploadId
            }
        } 
        else if(this.formChanges) {
            return {
                dateTimeOfChange: this.dateTimeOfChange,
                changeLocation: this.changeLocation,
                actionTaken: this.actionTaken,
                formChanges: this.formChanges
            }
        } else {
            return {
                dateTimeOfChange: this.dateTimeOfChange,
                changeLocation: this.changeLocation,
                actionTaken: this.actionTaken
            }
        }

    }

  }

  export interface IAuditRecord {
    dateTimeOfChange: number
    changeLocation: string //indicate the page the change was made. i.e. Algebra, license, testing, etc
    actionTaken: string  // Upload, delete, update, etc
    uploadId?: string
    formChanges?: any;
  }



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/services/auditRecordModel.ts